import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-local-loader',
  templateUrl: './local-loader.component.html',
  styleUrls: ['./local-loader.component.scss']
})
export class LocalLoaderComponent implements OnInit {

  @Input() lang;
  @Input() state = 'loading';

  constructor(protected translate: TranslateService) { }

  ngOnInit() {
  }

}
